import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

const ModalLeerCoMaedcv = ({ isOpen, toggle, selectedRecord }) => {
    // Parse selectedRecord to get claemp, tipfol, numfol
    const [claemp, tipfol, numfol] = selectedRecord.split('-');

    return (
        <Modal isOpen={isOpen} toggle={toggle} size="lg">
            <ModalHeader toggle={toggle}>Ver Registro CO_MAEDCV</ModalHeader>
            <ModalBody>
                <p><strong>Empresa:</strong> {claemp}</p>
                <p><strong>Tipo Folio:</strong> {tipfol}</p>
                <p><strong>Número Folio:</strong> {numfol}</p>
                {/* Add more fields display here */}
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggle}>Cerrar</Button>
            </ModalFooter>
        </Modal>
    );
};

export default ModalLeerCoMaedcv;